import React from 'react';

const FeaturesTableColumn = ({
  title,
  description,
  name,
  content,
  columnStyles,
  minimal,
}) => {
  return (
    <div
      className={
        minimal
          ? 'features-table-column features-table-column--minimal'
          : 'features-table-column'
      }
      style={columnStyles}
    >
      {name && <div className="features-table-column__name">{name}</div>}
      <div className="features-table-column__content">
        {title && <h5 className="features-table-column__title">{title}</h5>}
        {description && (
          <p className="features-table-column__description">{description}</p>
        )}
        {content && content}
      </div>
    </div>
  );
};

export default FeaturesTableColumn;
